import { FC } from 'react';

import { InstructionsDecorator } from 'pages/BusinessToolPage/components/InstructionsDecorator';

// import { useChangeSections } from 'hooks/useChangeSections';
// import { useSwipe } from 'hooks/useSwipe';

import { AIAssistantAlertCard } from 'components/BusinessToolForm/components/AIAssistantAlertCard/AIAssistantAlertCard';

import { IBusinessPageToolLayoutProps } from './types';

import styles from './BusinessToolPageMobileLayout.module.scss';

export const MobileLayout: FC<IBusinessPageToolLayoutProps> = ({
  header,
  form,
  modeSwitch,
  sectionsNavigation,
  navigationButtons,
}) => {
  // TODO Turned off for a while
  // const { setPrevSection, setNextSection } = useChangeSections();
  // const swipeHandlers = useSwipe({ onSwipedLeft: setNextSection, onSwipedRight: setPrevSection });

  return (
    <>
      <div>
        <div className={styles['top_section']}>
          <div className={styles['header']}>{header}</div>
          <div className={styles['mode_switch']}>{modeSwitch}</div>
          <div className={styles['section_navigation_wrapper']}>{sectionsNavigation}</div>
        </div>
        <div className={styles['content']}>{form}</div>
        {navigationButtons && <div className={styles['footer']}>{navigationButtons}</div>}
      </div>
      <AIAssistantAlertCard isMobileView />
      <InstructionsDecorator />
    </>
  );
};
